<template>
  <div @click.stop="showDetailsClicked">
    <div>{{ formatCurrency(object.completed_sum) }}</div>
    <div v-if="showDetails" class="mt-2 small text-muted">
      <div v-for="(d, dind) in details"
           :class="{ 'mt-1': dind > 0 }"
           :key="`d-${dind}`">
        <div>{{ d.title }} - {{ formatCurrency(d.sum) }}</div>
        <div v-if="d.recordIds.length">({{ d.recordIds.join(', ') }})</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {formatCurrency} from "@/extensions/filters/filters"
import {ref} from "vue"
import {PatientService} from "@/services/api/patient.api.service"

const props = defineProps({
  object: {
    type: Object
  },
  field: {
    type: Object
  },
})

const details = ref(null)
const showDetails = ref(false)

const showDetailsClicked = async () => {
  if(showDetails.value) {
    showDetails.value = false
    return
  }
  if(!showDetails.value && details.value) {
    showDetails.value = true
    return
  }
  try {
    const res = await PatientService.getPlanTreatmentCompletedDetails(props.object.planning_id)
    details.value = res?.data
    showDetails.value = true
  } catch (e) {
    console.error(e)
  }
}
</script>
